import { END_POINT } from "../../constants/api.constants";

const { SIGNUP } = END_POINT;

const signupProcess = async (userData) => {
  try {
    const response = await fetch(SIGNUP, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
      },
      body: JSON.stringify(userData),
    });

    const data = await response.json();
    
    if (!response.ok) {
      throw new Error(data.message || 'Registration failed');
    }

    if (data.status === true) {
      return {
        status: true,
        token: data.data?.token,
        user: data.data?.user,
        message: data.message || 'Registration successful'
      };
    } else {
      return {
        status: false,
        message: data.message || 'Registration failed. Please try again.'
      };
    }
  } catch (error) {
    console.error('Signup error:', error);
    return {
      status: false,
      message: error.message || 'An error occurred during registration. Please try again.'
    };
  }
};

export default signupProcess;
